exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) !important;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n  margin-top: 11px;\n}", ""]);

